<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <modal-header-default
    class="border"
		[options]="{
			showPrevious: true
		}">
  </modal-header-default>

  @if (cashOutViewModel$ | async; as vm) {
    <div class="cash-out-body">
      <h1 class="cash-out-title">{{ "cash_plus_cash_out_wallet_title" | translate }}</h1>
      <div class="cash-out-content">
        <div class="cash-out-values">
          <span>{{ "cash_plus_free_up_cp_balance" | translate }}</span>
          <span class="cash-out-amounts">{{
            vm.cpPortfolioApi.parked_asset_balance
            | fiat_precision_symbol
            : {
            id: vm.fiatId,
            symbol: true
          }
        }}</span>
      </div>
      <div class="cash-out-values">
        <span>{{ "cash_plus_free_up_wallet_balance" | translate }}</span>
        <span class="cash-out-amounts">{{
          vm.cpPortfolioApi.available_asset_balance
          | fiat_precision_symbol
          : {
          id: vm.fiatId,
          symbol: true
        }
      }}</span>
    </div>
  </div>
  @if (isDynamictermAndConditionActive$ | async) {
    <!-- dynamic -->
    <div left class="cash-out-toggles">
      <terms-and-conditions-updates [bundles]="bundles"></terms-and-conditions-updates>
    </div>
  } @else {
    <bp-switch [model]="cash_plus_toggle" field="enabled">
      <div left class="cash-out-toggles">
        <span>{{ "cash_plus_opt_out_sentence_slider" | translate }}</span>
      </div>
    </bp-switch>
  }
  <button
    class="btn btn-primary cash-out-btn btn-lg"
    (click)="cashOut(vm.fiatPid)"
    [ngClass]="{ disabled: !acceptedAll() }"
    >{{ "summary_button_confirm" | translate }}</button
    >
  </div>
}
</div>
